import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Composant de remplacement, jamais instancie.
 *
 * L'export SAP s'ouvre en modale par `ouvrirFichierSapGuard`, qui annule la
 * navigation pour laisser la page en cours affichee derriere. La route n'a donc
 * rien a rendre — mais Angular refuse une route feuille sans composant
 * (`NG04014`), d'ou cette coquille. Le garde s'executant avant l'activation,
 * elle n'est jamais construite : le test du garde le verifie.
 */
@Component({
  selector: 'app-fichier-sap.route',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
})
export class FichierSapRouteComponent {}
